import "./IconClose.scss";
import { ReactComponent as CloseIcon } from "./svg/icon_close.svg";
import { ReactComponent as CloseIcon2 } from "./svg/icon_close_2.svg";

type Props = {
  width: string;
  height: string;
  color?: "black" | "grey" | "white";
  useAlternateIcon?: boolean;
};

export const IconClose = (props: Props) => {
  const { width, height, color = "black", useAlternateIcon = false } = props;

  if (useAlternateIcon) {
    return (
      <span className={`icon-close icon-close__${color}`} style={{ width, height }}>
        <CloseIcon2 />
      </span>
    );
  }

  return (
    <span className={`icon-close icon-close__${color}`} style={{ width, height }}>
      <CloseIcon />
    </span>
  );
};
